import {VenueSettingsFactory} from 'Shared/VenueSettingsFactory';
import { Integer, SingleSelect } from 'Shared/forms/Inputs'
import { LabelOnLeftWrap } from 'Shared/forms/Wrap'
import { useBuild, useSite } from 'Shared/SiteProvider';
import { Show } from 'solid-js';
import { css } from '@emotion/css';
import { verticalStyle } from 'Shared/backend/Theme';

const posterOptions = {
	music: 'Music events',
	nonMusic: 'Non-music events',
	events: 'Mixed events',
	specials: 'Specials',
};

export const contentOptions = {
	...posterOptions,
	hours: 'Business hours',
	emails: 'Emails',
	socials: 'Socials',
	address: 'Address',
};


//XXX should we just allow the flip to carousels for specials?

export function Content(P)
{
	const typeStyle = css({
		display: 'flex',
		gap: '2em',

		'& > *': {
			width: 'unset'
		}
	});

	return (
		<div class={verticalStyle()}>
			<div class={typeStyle}>
				<LabelOnLeftWrap label='Type' required={true}>
					<SingleSelect {...P} field='type' required={true} options={contentOptions}/>
				</LabelOnLeftWrap>

				<Show when={P.type == 'specials'}>
					<LabelOnLeftWrap label='Specials type' required={true}>
						<SingleSelect {...P} field='specialsType' required={true} options={specialOptions()} />
					</LabelOnLeftWrap>
				</Show>
			</div>

			<Show when={P.type in posterOptions}>
				<LabelOnLeftWrap label='Flip to horizontal scrolling list if events exceed:'>
					<Integer {...P} field='carouselToScroll'/>
				</LabelOnLeftWrap>
			</Show>
		</div>
	);
}

export function specialOptions()
{
	//XXX its more of a setting than a theme element...
	return (new VenueSettingsFactory(useBuild())).createSettings(useSite().key).siteTheme().specials;
}

